/* eslint-disable camelcase */
import { loadScript } from 'src/util/helper';
import storage from 'src/util/storage';

const GTM_ID = 'GTM-WMP4TLD';

// Setup data layer
window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
	'gtm.start': new Date().getTime(),
	'event': 'gtm.js',
});

if (storage.get('auth.currentUser')) {
	window.dataLayer.push({
		userId: `${storage.get('auth.currentUser').ID}`,
	});
}

// Disable gtm on development
window[`ga-disable-${GTM_ID}`] = process.env.DEV;

// Load gtm script
loadScript(`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`)
	.catch(console.error);

// Handle Errors
const console_error = console.error;
console.error = (...args) => {
	handleError(...args);
	console_error(...args);
};

window.addEventListener('error', (event) => {
	handleError(event.error);
});

function handleError(...args) {
	args = args.map((arg) => {
		if (arg instanceof Error) return arg.stack;
		return String(arg);
	});

	if (window && window.dataLayer) {
		window.dataLayer.push({
			event: 'error',
			category: 'error',
			action: 'Error',
			label: args.join(' '),
		});
	}
}

// Connect to app
export default async ({ store, router }) => {
	store.subscribe(({ type, payload }) => {
		if (type !== 'auth/SET_CURRENT_USER') return;
		window.dataLayer.push({
			userId: `${payload.ID}`,
		});
	});

	router.afterEach((to) => {
		window.dataLayer.push({
			event: 'Pageview',
			pageTitle: to.name,
			pagePath: to.path,
			pageLocation: window.location.href,
		});
	});
};
